import { Api } from './cc-api';

export const CodeCritic = new Api();